import * as Accordion from "@radix-ui/react-accordion";
import { Plus } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const FAQAccordion = ({ items, dark = false }) => (
  <Accordion.Root type="single" collapsible data-testid="faq-accordion" className="w-full">
    {items.map((item, i) => (
      <Reveal key={i} delay={i * 0.04}>
        <Accordion.Item value={`item-${i}`} className={`border-b ${dark ? "border-coalline" : "border-line"}`}>
          <Accordion.Header>
            <Accordion.Trigger
              data-testid={`faq-question-${i}`}
              className={`group flex w-full items-center justify-between gap-6 py-6 text-left transition-colors ${
                dark ? "text-ivory hover:text-pine-2" : "text-ink hover:text-pine"
              }`}
            >
              <span className="text-base sm:text-lg font-medium tracking-tight">{item.q}</span>
              <Plus size={18} className="shrink-0 transition-transform duration-300 group-data-[state=open]:rotate-45" aria-hidden="true" />
            </Accordion.Trigger>
          </Accordion.Header>
          <Accordion.Content className="overflow-hidden data-[state=open]:animate-accordion-down data-[state=closed]:animate-accordion-up">
            <p className={`pb-7 pr-10 text-sm sm:text-base leading-relaxed ${dark ? "text-[#A0A09C]" : "text-dim"}`} data-testid={`faq-answer-${i}`}>
              {item.a}
            </p>
          </Accordion.Content>
        </Accordion.Item>
      </Reveal>
    ))}
  </Accordion.Root>
);

export default FAQAccordion;
